/* Cabin Boy Knits — site script (no dependencies) */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (m) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]; }); };
  var money = function (n) { return "$" + Number(n).toFixed(2).replace(/\.00$/, "") + " " + ((window.CBK && window.CBK.currency) || "CAD"); };

  /* ---------- Shopify bridge ----------
     window.CBK is emitted by snippets/cbk-data.liquid. The fallbacks keep this
     script working if it is ever opened outside the theme. */
  function R() { return (window.CBK && window.CBK.routes) || { root: "/", cart: "/cart", yarn: "/pages/yarn", dyes: "/pages/dyes", sheep: "/pages/sheep" }; }

  function themeImg(kind, id) {
    var m = window.CBK && window.CBK.img && window.CBK.img[kind];
    return (m && m[id]) || "";
  }

  function dyeImg(id) { return themeImg("dyes", id); }

  function sheepImg(s) { return themeImg("sheep", s.id) || s.img || ""; }

  /* ---------- the live catalogue ----------
     Shopify owns price, stock, photo and URL. assets/overlay.js supplies the
     editorial name and the weight / fibre / dye / breed facets we filter on.
     A product with no overlay entry still shows up — its facets are read off
     the Shopify tags instead, so newly added yarn appears without a code change. */
  var WEIGHTS = ["Fingering", "Sport", "DK", "Worsted", "Aran", "Bulky"];

  function knownDyeNames() {
    return (window.CBK_DYES || []).map(function (d) { return d.name; })
      .concat((window.CBK_DYES_MORE || []).map(function (d) { return d.name; }));
  }

  function knownBreedNames() {
    return (window.CBK_SHEEP || []).map(function (s) { return s.filter; }).filter(Boolean);
  }
  // match a product's tags against a known vocabulary, case-insensitively,
  // returning the tidy spelling from the vocabulary rather than the tag's
  function matchVocab(tags, vocab) {
    var low = tags.map(function (t) { return String(t).toLowerCase().trim(); });
    return vocab.filter(function (v) { return low.indexOf(v.toLowerCase()) > -1; });
  }
  // Shopify titles carry a lot of shop admin ("DK - BFL/Masham \"Goldenrod\"").
  // Prefer whatever sits in quotes; otherwise drop a leading weight prefix.
  function tidyTitle(t) {
    var q = String(t).match(/[""“”]\s*([^""“”]+?)\s*[""“”]/);
    if (q && q[1].trim()) {
      return q[1].trim().replace(/\s+/g, " ").replace(/\b\w+/g, function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
      });
    }
    return String(t).replace(/^\s*(fingering|sport|dk|worsted|aran|bulky|chunky)\s*[-–—]\s*/i, "").trim();
  }

  function loadProducts() {
    return fetch("/products.json?limit=250", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var over = window.CBK_OVERLAY || {};
        var dyeVocab = knownDyeNames(), breedVocab = knownBreedNames();
        // /products.json is the whole shop; the catalogue is only the yarn
        var skip = ((window.CBK && window.CBK.nonYarn) || []).filter(Boolean);
        window.CBK_PRODUCTS = (data.products || []).filter(function (p) {
          return skip.indexOf(p.handle) === -1;
        }).map(function (p) {
          var o = over[p.handle] || {};
          var v = (p.variants || [])[0] || {};
          var tags = p.tags || [];
          var hay = (p.title + " " + tags.join(" ")).toLowerCase();
          return {
            id: p.handle,
            name: o.name || tidyTitle(p.title),
            weight: o.weight || (matchVocab(tags, WEIGHTS)[0] || ""),
            fibre: o.fibre || p.product_type || "",
            dyes: o.dyes || matchVocab(tags, dyeVocab),
            breeds: o.breeds || matchVocab(tags, breedVocab),
            sock: o.sock !== undefined ? o.sock : /\bsock\b/.test(hay),
            organic: o.organic !== undefined ? o.organic : /\borganic\b/.test(hay),
            price: parseFloat(v.price || 0),
            available: !!v.available,
            img: (p.images && p.images[0] && p.images[0].src) || "",
            url: "/products/" + p.handle,
            variantId: v.id
          };
        });
      })
      .catch(function () { window.CBK_PRODUCTS = window.CBK_PRODUCTS || []; });
  }

  /* ---------- dye colour lookup ---------- */
  var DYE_INDEX = {};

  function indexDyes() {
    (window.CBK_DYES || []).forEach(function (d) { DYE_INDEX[d.name.toLowerCase()] = d.sw; DYE_INDEX[d.id.replace(/-/g, " ")] = d.sw; });
    (window.CBK_DYES_MORE || []).forEach(function (d) { DYE_INDEX[d.name.toLowerCase()] = d.sw; });
    DYE_INDEX["onion"] = DYE_INDEX["onion skins"]; DYE_INDEX["sumac"] = DYE_INDEX["staghorn sumac"]; DYE_INDEX["spruce"] = DYE_INDEX["white spruce"];
  }

  function dyeColour(name) { return DYE_INDEX[String(name).toLowerCase()] || "#8C7B6E"; }

  function dyeId(name) {
    var n = String(name).toLowerCase();
    var hit = (window.CBK_DYES || []).filter(function (d) { return d.name.toLowerCase() === n || d.id.replace(/-/g, " ") === n || (n === "onion" && d.id === "onion") || (n === "sumac" && d.id === "sumac"); })[0];
    return hit ? hit.id : null;
  }

  /* ---------- header + mobile menu ---------- */
  function header() {
    var hdr = $(".hdr"); if (!hdr) return;
    var onScroll = function () { hdr.setAttribute("data-stuck", window.scrollY > 8 ? "true" : "false"); };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    var burger = $(".burger"), drawer = $("#menu");
    if (!burger || !drawer) return;
    function setOpen(open) {
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      drawer.setAttribute("data-open", open ? "true" : "false");
      document.body.setAttribute("data-menu", open ? "open" : "closed");
      if (open) { var first = $("a", drawer); first && first.focus(); }
    }
    burger.addEventListener("click", function () { setOpen(burger.getAttribute("aria-expanded") !== "true"); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && burger.getAttribute("aria-expanded") === "true") { setOpen(false); burger.focus(); } });
    $$("a", drawer).forEach(function (a) { a.addEventListener("click", function () { setOpen(false); }); });
    window.addEventListener("resize", function () { if (window.innerWidth > 900) setOpen(false); });
    // mark current page
    var tidy = function (p) { return (p || "").split("?")[0].split("#")[0].replace(/\/+$/, "") || "/"; };
    var here = tidy(location.pathname);
    $$(".nav a, .drawer a, .ftr a").forEach(function (a) {
      if (tidy(a.getAttribute("href")) === here) a.setAttribute("aria-current", "page");
    });
  }

  /* ---------- scroll reveal ---------- */
  function reveal() {
    var els = $$("[data-reveal]"); if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    // belt and braces: anything already in view at load (e.g. landing on a #hash) shows at once
    els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) e.classList.add("is-in"); });
  }

  /* ---------- dye ticker ---------- */
  function ticker() {
    var t = $(".ticker"); if (!t) return;
    var items = (window.CBK_DYES || []).map(function (d) {
      return '<li style="--sw:' + d.sw + '"><i></i><a href="' + R().dyes + '#' + d.id + '">' + esc(d.name) + '</a></li>';
    }).join("");
    t.innerHTML = '<div class="ticker__track" aria-hidden="true"><ul>' + items + '</ul><ul>' + items + '</ul></div>';
  }

  /* ---------- product cards ---------- */
  function bandHTML(dyes) { return '<div class="card__band" aria-hidden="true">' + dyes.map(function (d) { return '<i style="background:' + dyeColour(d) + '"></i>'; }).join("") + "</div>"; }

  function cardHTML(p) {
    var alt = p.name + " — " + p.weight + " weight " + p.fibre + " yarn, naturally dyed with " + p.dyes.join(" and ") + " at Cabin Boy Knits";
    var badge = !p.available ? '<span class="badge badge--out">Sold out</span>' : p.organic ? '<span class="badge badge--organic">Organic</span>' : "";
    return '<article class="card' + (p.available ? "" : " card--soldout") + '" data-sw="' + p.dyes.map(dyeColour).join(",") + '">' + badge + bandHTML(p.dyes) +
      '<div class="card__img"><img src="' + p.img + '" alt="' + esc(alt) + '" loading="lazy" width="720" height="540"></div>' +
      '<div class="card__body"><div class="card__kicker">' + esc(p.weight) + (p.sock ? " · Sock" : "") + '</div>' +
      '<h3 class="card__name"><a href="' + p.url + '">' + esc(p.name) + '</a></h3>' +
      '<div class="card__fibre">' + esc(p.fibre) + '</div>' +
      '<div class="card__foot"><span class="card__price">' + money(p.price) + '</span><span class="card__buy">' + (p.available ? "Buy" : "View") + '</span></div></div></article>';
  }

  function renderCards(el, list) { el.innerHTML = list.map(cardHTML).join(""); }

  function featured() {
    var el = $("#featured"); if (!el) return;
    var P = (window.CBK_PRODUCTS || []).filter(function (p) { return p.available; });
    // one of each weight first, then fill — so the home grid shows the range
    var picks = [], seen = {};
    ["Fingering", "DK", "Worsted", "Bulky", "Sport"].forEach(function (w) {
      var hit = P.filter(function (p) { return p.weight === w && p.dyes.length > 1 && !seen[p.id]; })[0] || P.filter(function (p) { return p.weight === w && !seen[p.id]; })[0];
      if (hit) { picks.push(hit); seen[hit.id] = true; }
    });
    var wantDyes = ["Cochineal", "Goldenrod", "Walnut", "Brazilwood", "Madder", "White Spruce", "Onion", "Avocado"];
    wantDyes.forEach(function (d) {
      if (picks.length >= 8) return;
      var hit = P.filter(function (p) { return !seen[p.id] && p.dyes.indexOf(d) > -1; })[0];
      if (hit) { picks.push(hit); seen[hit.id] = true; }
    });
    P.forEach(function (p) { if (picks.length < 8 && !seen[p.id]) { picks.push(p); seen[p.id] = true; } });
    renderCards(el, picks.slice(0, 8));
  }

  /* ---------- catalogue ---------- */
  function catalogue() {
    var grid = $("#catalogue"); if (!grid) return;
    var P = window.CBK_PRODUCTS || [];
    var params = new URLSearchParams(location.search);
    var state = { weight: params.get("weight") || "All", breed: params.get("breed") || "", dye: params.get("dye") || "", q: params.get("q") || "", stock: false, sort: "featured" };
    var weightBtns = $$("#weights button");
    var breedSel = $("#f-breed"), dyeSel = $("#f-dye"), sortSel = $("#f-sort"), search = $("#f-q"), stock = $("#f-stock"), count = $("#f-count"), reset = $("#f-reset");
    var breeds = {}; var dyes = {};
    P.forEach(function (p) { p.breeds.forEach(function (b) { breeds[b] = (breeds[b] || 0) + 1; }); p.dyes.forEach(function (d) { dyes[d] = (dyes[d] || 0) + 1; }); });
    Object.keys(breeds).sort().forEach(function (b) { breedSel.insertAdjacentHTML("beforeend", '<option value="' + esc(b) + '">' + esc(b) + " (" + breeds[b] + ")</option>"); });
    Object.keys(dyes).sort().forEach(function (d) { dyeSel.insertAdjacentHTML("beforeend", '<option value="' + esc(d) + '">' + esc(d) + " (" + dyes[d] + ")</option>"); });
    function norm(s) { return String(s).toLowerCase(); }
    function matchDye(p, d) { return p.dyes.some(function (x) { return norm(x) === norm(d) || norm(x).indexOf(norm(d)) > -1; }); }
    function matchBreed(p, b) { return p.breeds.some(function (x) { return norm(x) === norm(b); }); }
    function apply() {
      var list = P.filter(function (p) {
        if (state.weight !== "All" && p.weight !== state.weight) return false;
        if (state.breed && !matchBreed(p, state.breed)) return false;
        if (state.dye && !matchDye(p, state.dye)) return false;
        if (state.stock && !p.available) return false;
        if (state.q) { var h = norm(p.name + " " + p.fibre + " " + p.weight + " " + p.dyes.join(" ") + " " + p.breeds.join(" ")); if (h.indexOf(norm(state.q)) === -1) return false; }
        return true;
      });
      if (state.sort === "low") list = list.slice().sort(function (a, b) { return a.price - b.price; });
      if (state.sort === "high") list = list.slice().sort(function (a, b) { return b.price - a.price; });
      if (state.sort === "name") list = list.slice().sort(function (a, b) { return a.name.localeCompare(b.name); });
      if (state.sort === "featured") list = list.slice().sort(function (a, b) { return (b.available - a.available); });
      if (!list.length) grid.innerHTML = '<div class="empty"><p class="display-s">Nothing in the pot for that combination.</p><p class="muted">Try another weight or dye, or clear the filters.</p></div>';
      else renderCards(grid, list);
      count.textContent = list.length + " of " + P.length + " skeins";
      weightBtns.forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.weight === state.weight ? "true" : "false"); });
      // keep URL shareable
      var u = new URLSearchParams();
      if (state.weight !== "All") u.set("weight", state.weight);
      if (state.breed) u.set("breed", state.breed);
      if (state.dye) u.set("dye", state.dye);
      if (state.q) u.set("q", state.q);
      var qs = u.toString(); history.replaceState(null, "", location.pathname + (qs ? "?" + qs : ""));
    }
    // seed controls from URL (match option values case-insensitively)
    function seedSelect(sel, val) { var o = $$("option", sel).filter(function (o) { return norm(o.value) === norm(val); })[0]; if (o) { sel.value = o.value; return o.value; } return ""; }
    state.breed = state.breed ? seedSelect(breedSel, state.breed) : "";
    state.dye = state.dye ? seedSelect(dyeSel, state.dye) : "";
    if (!weightBtns.some(function (b) { return b.dataset.weight === state.weight; })) state.weight = "All";
    search.value = state.q;
    weightBtns.forEach(function (b) { b.addEventListener("click", function () { state.weight = b.dataset.weight; apply(); }); });
    breedSel.addEventListener("change", function () { state.breed = breedSel.value; apply(); });
    dyeSel.addEventListener("change", function () { state.dye = dyeSel.value; apply(); });
    sortSel.addEventListener("change", function () { state.sort = sortSel.value; apply(); });
    stock.addEventListener("change", function () { state.stock = stock.checked; apply(); });
    search.addEventListener("input", function () { state.q = search.value.trim(); apply(); });
    reset.addEventListener("click", function () { state = { weight: "All", breed: "", dye: "", q: "", stock: false, sort: "featured" }; breedSel.value = ""; dyeSel.value = ""; sortSel.value = "featured"; search.value = ""; stock.checked = false; apply(); });
    // the birch behind the shelves washes in the colour of the yarn under the
    // cursor — two stacked layers cross-fade so every switch is a soft fade
    var tintEls = $$(".cat-tint");
    if (tintEls.length === 2) {
      var tintSec = tintEls[0].closest("section");
      var tintActive = 0, tintLast = "";
      var hexA = function (h, a) { return "rgba(" + parseInt(h.slice(1, 3), 16) + "," + parseInt(h.slice(3, 5), 16) + "," + parseInt(h.slice(5, 7), 16) + "," + a + ")"; };
      var paintTint = function (bg) {
        if (bg === tintLast) return;
        tintLast = bg;
        if (!bg) { tintEls[0].style.opacity = "0"; tintEls[1].style.opacity = "0"; return; }
        var next = 1 - tintActive;
        tintEls[next].style.background = bg;
        tintEls[next].style.opacity = "1";
        tintEls[tintActive].style.opacity = "0";
        tintActive = next;
      };
      tintSec.addEventListener("mouseover", function (e) {
        var card = e.target.closest(".card[data-sw]");
        if (card) {
          var cols = card.getAttribute("data-sw").split(",").map(function (c) { return c.trim(); }).filter(function (c) { return /^#[0-9a-fA-F]{6}$/.test(c); });
          if (cols.length > 1) paintTint("linear-gradient(135deg," + cols.map(function (c) { return hexA(c, .5); }).join(",") + ")");
          else if (cols.length) paintTint(hexA(cols[0], .5));
        } else if (!e.target.closest(".card")) {
          paintTint("");
        }
      });
      tintSec.addEventListener("mouseleave", function () { paintTint(""); });
    }
    apply();
  }

  // Shopify's own product titles carry a lot of shop admin ("DK - Wensleydale
  // “ Marigold/Indigo”"). Anywhere Liquid had to print one — the basket, the
  // breadcrumb — swap in the curated colour name instead.
  function dressNames() {
    var over = window.CBK_OVERLAY || {};
    $$("[data-overlay-name]").forEach(function (el) {
      var o = over[el.getAttribute("data-overlay-name")];
      if (o && o.name) el.textContent = o.name;
    });
  }

  /* ---------- server-rendered cards ----------
     Collection and search pages render their cards in Liquid, so they arrive
     with Shopify's own title and no dye band. Once the overlay is in, give them
     the same treatment the catalogue cards get. */
  function dressCards() {
    var cards = $$(".card[data-overlay]"); if (!cards.length) return;
    var over = window.CBK_OVERLAY || {};
    cards.forEach(function (card) {
      var o = over[card.getAttribute("data-overlay")]; if (!o) return;
      var dyes = o.dyes || [];
      var band = $(".card__band", card);
      if (band && dyes.length) band.innerHTML = dyes.map(function (d) { return '<i style="background:' + dyeColour(d) + '"></i>'; }).join("");
      if (dyes.length) card.setAttribute("data-sw", dyes.map(dyeColour).join(","));
      var name = $(".card__name a", card); if (name && o.name) name.textContent = o.name;
      var kicker = $(".card__kicker", card);
      if (kicker) kicker.textContent = [o.weight, o.sock ? "Sock" : ""].filter(Boolean).join(" · ") || kicker.textContent;
      var fibre = $(".card__fibre", card); if (fibre && o.fibre) fibre.textContent = o.fibre;
      if (o.organic && !$(".badge", card)) {
        card.insertAdjacentHTML("afterbegin", '<span class="badge badge--organic">Organic</span>');
      }
    });
  }

  /* ---------- account forms ---------- */
  function accountForms() {
    // sign in / reset password live on one page and swap places
    $$("[data-auth-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var show = btn.getAttribute("data-auth-toggle");
        var login = $("#login"), recover = $("#recover");
        if (!login || !recover) return;
        var on = show === "recover" ? recover : login;
        var off = show === "recover" ? login : recover;
        off.hidden = true; on.hidden = false;
        var first = $("input", on); first && first.focus();
      });
    });
    // Shopify hangs the province list off each country option
    var country = $("#a-country"), province = $("#a-prov");
    if (!country || !province) return;
    var provinceField = province.closest(".field");
    function fill() {
      var opt = country.options[country.selectedIndex];
      var list = [];
      try { list = JSON.parse(opt.getAttribute("data-provinces") || "[]"); } catch (e) { list = []; }
      province.innerHTML = list.map(function (p) { return '<option value="' + esc(p[0]) + '">' + esc(p[1]) + "</option>"; }).join("");
      if (provinceField) provinceField.hidden = list.length === 0;
      var want = province.getAttribute("data-default");
      if (want) province.value = want;
    }
    var def = country.getAttribute("data-default");
    if (def) country.value = def;
    country.addEventListener("change", fill);
    fill();
  }

  /* ---------- the skein page ----------
     Liquid has already rendered the title, price and buy button. This adds the
     things only the curated overlay knows: the dye band, the facet chips that
     link back into the catalogue, and the skeins dyed from the same pots. */
  function productPage() {
    var pdp = $(".pdp"); if (!pdp) return;
    var handle = pdp.getAttribute("data-handle");

    // gallery
    var main = $("#pdp-main"), thumbs = $$(".pdp__thumb");
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        if (!main) return;
        main.removeAttribute("srcset");
        main.src = t.getAttribute("data-full");
        thumbs.forEach(function (x) { x.classList.toggle("is-on", x === t); });
      });
    });

    var o = (window.CBK_OVERLAY || {})[handle];
    if (!o) return;

    var dyes = o.dyes || [], breeds = o.breeds || [];

    if (o.name) {
      var h1 = $("#pdp-title"); if (h1) h1.textContent = o.name;
      document.title = o.name + " — " + (o.weight ? o.weight + " " : "") + (o.fibre || "") + " · Cabin Boy Knits";
    }
    var kicker = $("#pdp-kicker");
    if (kicker) kicker.textContent = [o.weight, o.sock ? "Sock" : "", o.fibre].filter(Boolean).join(" · ");

    var band = $("#pdp-band");
    if (band && dyes.length) band.innerHTML = dyes.map(function (d) { return '<i style="background:' + dyeColour(d) + '"></i>'; }).join("");
    // the sheep cursor reads data-sw, so the fleece takes this skein's colours
    if (dyes.length) pdp.setAttribute("data-sw", dyes.map(dyeColour).join(","));

    var chips = $("#pdp-chips");
    if (chips) {
      var bits = [];
      if (o.weight) bits.push('<a class="chip" href="' + R().yarn + '?weight=' + encodeURIComponent(o.weight) + '">' + esc(o.weight) + '</a>');
      dyes.forEach(function (d) {
        var id = dyeId(d);
        bits.push('<a class="chip" data-sw="' + dyeColour(d) + '" href="' + R().yarn + '?dye=' + encodeURIComponent(d) + '"><i style="background:' + dyeColour(d) + '"></i>' + esc(d) + '</a>');
        if (id) bits.push('<a class="chip chip--ghost" href="' + R().dyes + '#' + id + '">About ' + esc(d.toLowerCase()) + '</a>');
      });
      breeds.forEach(function (b) { bits.push('<a class="chip" href="' + R().yarn + '?breed=' + encodeURIComponent(b) + '">' + esc(b) + '</a>'); });
      chips.innerHTML = bits.join("");
    }

    var spec = $("#pdp-spec");
    if (spec) {
      var rows = [];
      if (o.weight) rows.push(["Weight", o.weight]);
      if (o.fibre) rows.push(["Fibre", o.fibre]);
      if (dyes.length) rows.push(["Dyed with", dyes.join(", ")]);
      if (breeds.length) rows.push([breeds.length > 1 ? "Breeds" : "Breed", breeds.join(", ")]);
      if (o.sock) rows.push(["Good for", "Socks — nylon in the blend"]);
      spec.innerHTML = rows.map(function (r) { return "<div><dt>" + esc(r[0]) + "</dt><dd>" + esc(r[1]) + "</dd></div>"; }).join("");
    }

    // related: same dye first, then same breed, in stock first
    var rel = $("#pdp-related"), wrap = $("#pdp-related-wrap");
    if (rel && wrap) {
      var P = (window.CBK_PRODUCTS || []).filter(function (p) { return p.id !== handle; });
      var score = function (p) {
        var s = 0;
        p.dyes.forEach(function (d) { if (dyes.indexOf(d) > -1) s += 3; });
        p.breeds.forEach(function (b) { if (breeds.indexOf(b) > -1) s += 2; });
        if (p.weight === o.weight) s += 1;
        if (p.available) s += 1;
        return s;
      };
      var picks = P.map(function (p) { return { p: p, s: score(p) }; })
        .filter(function (x) { return x.s > 1; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, 4).map(function (x) { return x.p; });
      if (picks.length) { renderCards(rel, picks); wrap.hidden = false; }
    }
  }

  /* ---------- dye library ---------- */
  function dyeLibrary() {
    var el = $("#dye-library"); if (!el) return;
    var P = window.CBK_PRODUCTS || [];
    var nav = $("#dye-nav");
    var html = (window.CBK_DYES || []).map(function (d, i) {
      var n = P.filter(function (p) { return p.dyes.some(function (x) { return x.toLowerCase() === d.name.toLowerCase() || d.id === x.toLowerCase().replace(/\s+/g, "-") || (d.id === "onion" && x === "Onion") || (d.id === "sumac" && x === "Sumac"); }); }).length;
      var filterName = d.id === "onion" ? "Onion" : d.id === "sumac" ? "Sumac" : d.name;
      var shop = n ? '<a class="btn btn--sm btn--arrow" href="' + R().yarn + '?dye=' + encodeURIComponent(filterName) + '">Shop ' + n + ' skein' + (n > 1 ? "s" : "") + ' dyed with ' + esc(d.name.toLowerCase()) + '</a>' : '<span class="mono muted">Not in the current batch</span>';
      return '<article class="lib-card" id="' + d.id + '" style="--sw:' + d.sw + '" data-sw="' + d.sw + '" data-reveal>' +
        '<div class="lib-card__media"><img src="' + dyeImg(d.id) + '" alt="' + esc(d.name) + ' — natural dye plant used at Cabin Boy Knits" loading="lazy" width="900" height="470"><i class="lib-card__sw"></i></div>' +
        '<div class="lib-card__body"><div class="lib-card__head"><h2>' + esc(d.name) + '</h2><span class="latin">' + esc(d.latin) + '</span></div>' +
        '<dl class="spec"><div><dt>Colour on wool</dt><dd>' + esc(d.colour) + '</dd></div><div><dt>Source</dt><dd>' + esc(d.source) + '</dd></div></dl>' +
        '<div class="yields" aria-label="Range of shades">' + d.yields.map(function (c) { return '<i style="background:' + c + '"></i>'; }).join("") + '</div>' +
        '<p>' + esc(d.story) + '</p><div class="lib-card__foot">' + shop + '</div></div></article>';
    }).join("");
    el.innerHTML = html;
    if (nav) nav.innerHTML = (window.CBK_DYES || []).map(function (d) { return '<a href="#' + d.id + '" style="--sw:' + d.sw + '" data-sw="' + d.sw + '"><i></i>' + esc(d.name) + '</a>'; }).join("");
    // the page behind the cards takes the colour of the dye under the cursor
    var sec = el.closest("section");
    if (sec) {
      sec.classList.add("section--dyebg");
      var lastSw = null;
      // the new colour blooms out of the point you touched, like dye in a vat,
      // while the base tone settles in underneath
      var splash = function (sw, x, y) {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        var s = document.createElement("span");
        s.className = "dye-splash";
        s.style.setProperty("--splash-c", "color-mix(in srgb, " + sw + " 82%, #191411)");
        s.style.left = x + "px"; s.style.top = y + "px";
        sec.appendChild(s);
        s.addEventListener("animationend", function () { s.remove(); });
        if (sec.querySelectorAll(".dye-splash").length > 4) sec.querySelector(".dye-splash").remove();
      };
      var tint = function (sw, x, y) {
        if (sw === lastSw) return;
        lastSw = sw;
        if (sw) {
          if (x != null) splash(sw, x, y);
          sec.style.setProperty("--dyebg", sw);
        } else {
          sec.style.removeProperty("--dyebg");
        }
      };
      sec.addEventListener("mouseover", function (e) {
        var c = e.target.closest("[data-sw]");
        if (c) { var r = sec.getBoundingClientRect(); tint(c.getAttribute("data-sw"), e.clientX - r.left, e.clientY - r.top); }
        else tint(null);
      });
      sec.addEventListener("mouseleave", function () { tint(null); });
      sec.addEventListener("focusin", function (e) {
        var c = e.target.closest("[data-sw]");
        if (c) { var r = sec.getBoundingClientRect(), cr = c.getBoundingClientRect(); tint(c.getAttribute("data-sw"), cr.left - r.left + cr.width / 2, cr.top - r.top + cr.height / 2); }
      });
      sec.addEventListener("focusout", function (e) { if (!e.relatedTarget || !e.relatedTarget.closest("[data-sw]")) tint(null); });
    }
    var more = $("#dye-more");
    if (more) {
      var moreSec = more.closest("section");
      if (moreSec) {
        moreSec.style.transition = "background 1s cubic-bezier(.2,.7,.2,1)";
        more.addEventListener("mouseover", function (e) {
          var chip = e.target.closest("[data-sw]");
          if (chip) moreSec.style.background = chip.getAttribute("data-sw");
        });
        moreSec.addEventListener("mouseleave", function () { moreSec.style.background = ""; });
      }
    }
    if (more) more.innerHTML = (window.CBK_DYES_MORE || []).map(function (d) {
      var n = P.filter(function (p) { return p.dyes.some(function (x) { return x.toLowerCase() === d.name.toLowerCase(); }); }).length;
      return n ? '<a class="chip chip--dark" data-sw="' + d.sw + '" href="' + R().yarn + '?dye=' + encodeURIComponent(d.name) + '"><i style="display:inline-block;width:10px;height:10px;border-radius:50%;background:' + d.sw + ';margin-right:.45em;vertical-align:-1px"></i>' + esc(d.name) + ' · ' + n + '</a>' : "";
    }).join("");
  }

  /* ---------- sheep ---------- */
  function sheepLibrary() {
    var el = $("#sheep-library"); if (!el) return;
    var P = window.CBK_PRODUCTS || [];
    var nav = $("#sheep-nav");
    el.innerHTML = (window.CBK_SHEEP || []).map(function (s) {
      var n = s.filter ? P.filter(function (p) { return p.breeds.indexOf(s.filter) > -1; }).length : 0;
      var shop = n ? '<a class="btn btn--sm btn--arrow" href="' + R().yarn + '?breed=' + encodeURIComponent(s.filter) + '">Shop ' + n + ' ' + esc(s.short || s.name) + ' skein' + (n > 1 ? "s" : "") + '</a>' : '<span class="mono muted">Not in the current batch</span>';
      return '<article class="lib-card" id="' + s.id + '" style="--sw:var(--spruce)" data-reveal>' +
        '<div class="lib-card__media"><img src="' + sheepImg(s) + '" alt="' + esc(s.name) + ' sheep" loading="lazy" width="900" height="470"><i class="lib-card__sw"></i></div>' +
        '<div class="lib-card__body"><div class="lib-card__head"><h2>' + esc(s.name) + (s.short ? ' <span class="muted">(' + esc(s.short) + ')</span>' : "") + '</h2><span class="latin">' + esc(s.origin) + '</span></div>' +
        '<dl class="spec spec--4"><div><dt>Microns</dt><dd>' + esc(s.microns) + '</dd></div><div><dt>Staple</dt><dd>' + esc(s.staple) + '</dd></div><div style="grid-column: span 2"><dt>Best for</dt><dd>' + esc(s.best) + '</dd></div></dl>' +
        '<p>' + esc(s.story) + '</p><div class="lib-card__foot">' + shop + '</div></div></article>';
    }).join("");
    if (nav) nav.innerHTML = (window.CBK_SHEEP || []).map(function (s) { return '<a href="#' + s.id + '" style="--sw:var(--spruce)"><i></i>' + esc(s.short || s.name) + '</a>'; }).join("");
  }

  /* ---------- home: dye swatch wall ---------- */
  // little cartoon emblems of each dye's source, drawn to read at 30px
  var DYE_ICONS = {
    "indigo": '<path d="M12 20V8"/><path d="M12 12C8.5 12 6.5 9.5 6.5 6.5c3 0 5.5 2 5.5 5.5z"/><path d="M12 9.5c3.5 0 5.5-2.5 5.5-5.5-3 0-5.5 2-5.5 5.5z"/>',
    "goldenrod": '<path d="M5 19C10 18 14.5 14 17.5 7.5"/><circle cx="16.5" cy="6" r="1.3" fill="currentColor" stroke="none"/><circle cx="14" cy="10" r="1.3" fill="currentColor" stroke="none"/><circle cx="10.5" cy="14" r="1.3" fill="currentColor" stroke="none"/><circle cx="6.5" cy="17" r="1.3" fill="currentColor" stroke="none"/>',
    "cochineal": '<ellipse cx="12" cy="13.5" rx="4.6" ry="5.6"/><path d="M12 8v11M7.6 10.5 5 8.8M7.4 13.5H4.4M7.6 16.5 5 18.2M16.4 10.5 19 8.8M16.6 13.5h3M16.4 16.5 19 18.2"/><circle cx="12" cy="5.8" r="1.7"/>',
    "madder": '<path d="M12 7.5c2.8 0 3.8 2.8 3 5.6L12 20.5l-3-7.4c-.8-2.8.2-5.6 3-5.6z"/><path d="M12 7.5V4M9.5 4.8C10.5 6 13.5 6 14.5 4.8M9.6 12.5l-2.4 1M14.4 12.5l2.4 1M12 15.5v2"/>',
    "marigold": '<circle cx="12" cy="12" r="3"/><path d="M12 4.5v2.6M12 16.9v2.6M4.5 12h2.6M16.9 12h2.6M6.7 6.7l1.9 1.9M15.4 15.4l1.9 1.9M17.3 6.7l-1.9 1.9M8.6 15.4l-1.9 1.9"/>',
    "white-spruce": '<path d="M12 3.5 6.5 12h3.2L5.5 19h13l-4.2-7h3.2z"/><path d="M12 19v2.3"/>',
    "sumac": '<path d="M12 4.5c2.8 2 3.8 5.5 3.8 9L12 19.5l-3.8-6c0-3.5 1-7 3.8-9z"/><path d="M12 7v9M9.6 10l2.4 1.8L14.4 10M9.4 13.5l2.6 1.8 2.6-1.8"/>',
    "logwood": '<rect x="3.5" y="9" width="13.5" height="7" rx="1.5"/><ellipse cx="18.7" cy="12.5" rx="2.2" ry="3.5"/><circle cx="18.7" cy="12.5" r=".9"/>',
    "onion": '<path d="M12 8.2c3.8 1.2 5.8 3.8 5.8 6.8a5.8 5.8 0 0 1-11.6 0c0-3 2-5.6 5.8-6.8z"/><path d="M12 8.2V4.8M10 6l2-1.2L14 6"/><path d="M9.7 11.5c-.7 1.3-.7 3.5 0 4.8M14.3 11.5c.7 1.3.7 3.5 0 4.8"/>',
    "brazilwood": '<path d="M4 16l5.2-3 4 2-5.2 3z"/><path d="M10.8 11.5l5.2-3 4 2-5.2 3z"/>',
    "avocado": '<path d="M12 4c2 3.2 5.8 5 5.8 10a5.8 5.8 0 0 1-11.6 0C6.2 9 10 7.2 12 4z"/><circle cx="12" cy="14.5" r="2.5"/>',
    "alkanet": '<circle cx="12" cy="12" r="1.7"/><circle cx="12" cy="7.6" r="2.3"/><circle cx="16.3" cy="10.7" r="2.3"/><circle cx="14.6" cy="15.8" r="2.3"/><circle cx="9.4" cy="15.8" r="2.3"/><circle cx="7.7" cy="10.7" r="2.3"/>'
  };

  function dyeIconSVG(id) {
    var p = DYE_ICONS[id]; if (!p) return "";
    return '<i class="swatch__ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg></i>';
  }

  function swatchWall() {
    var el = $("#swatch-wall"); if (!el) return;
    var want = ["indigo", "goldenrod", "cochineal", "madder", "marigold", "white-spruce", "sumac", "logwood", "onion", "brazilwood", "avocado", "alkanet"];
    el.innerHTML = want.map(function (id) {
      var d = (window.CBK_DYES || []).filter(function (x) { return x.id === id; })[0]; if (!d) return "";
      var light = ["goldenrod", "marigold", "white-spruce", "avocado", "onion"].indexOf(id) > -1;
      return '<a class="swatch' + (light ? " swatch--light" : "") + '" href="' + R().dyes + '#' + d.id + '" style="--sw:' + d.sw + '">' + dyeIconSVG(d.id) + '<span>' + esc(d.name) + '<small>' + esc(d.colour.split(/[,;]/)[0]) + '</small></span></a>';
    }).join("");
    // the whole band takes the colour of whichever swatch the cursor is over
    var sec = el.closest("section");
    if (sec) {
      el.addEventListener("mouseover", function (e) {
        var s = e.target.closest(".swatch");
        if (s) sec.style.background = getComputedStyle(s).getPropertyValue("--sw").trim();
      });
      sec.addEventListener("mouseleave", function () { sec.style.background = ""; });
    }
  }

  /* ---------- forms ---------- */
  function validate(form) {
    var ok = true;
    $$("[required]", form).forEach(function (f) {
      var field = f.closest(".field"); var bad = !f.value.trim() || (f.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value));
      if (field) field.classList.toggle("field--error", bad);
      if (bad) ok = false;
    });
    return ok;
  }
  // The contact and wholesale forms are Shopify contact forms — Shopify sends the
  // mail and handles the reply-to. This only adds the inline field validation the
  // design calls for; a valid form submits normally.
  function enquiryForms() {
    $$("form[data-validate]").forEach(function (form) {
      form.setAttribute("novalidate", "");
      $$("[required]", form).forEach(function (f) { f.addEventListener("input", function () { var fl = f.closest(".field"); fl && fl.classList.remove("field--error"); }); });
      form.addEventListener("submit", function (e) {
        if (validate(form)) return;
        e.preventDefault();
        var first = $(".field--error input, .field--error textarea, .field--error select", form);
        first && first.focus();
      });
    });
    // Shopify redirects back with the confirmation rendered — put focus on it
    var posted = $(".form__ok[data-posted]");
    if (posted) { posted.setAttribute("tabindex", "-1"); posted.focus(); }
  }

  /* ---------- misc ---------- */
  function year() { $$("[data-year]").forEach(function (e) { e.textContent = new Date().getFullYear(); }); }
  // the cursor is a ball of yarn that keeps the colour of the last skein it touched
  function yarnCursor() {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    function shade(hex, f) {
      var n = parseInt(hex.slice(1), 16);
      var r = Math.round(((n >> 16) & 255) * f), g = Math.round(((n >> 8) & 255) * f), b = Math.round((n & 255) * f);
      return "rgb(" + r + "," + g + "," + b + ")";
    }
    var UNDYED = "#F6F2E8";
    var INK = "#3B2E25";
    var lastKey = "";
    // a little sheep. pose "graze" = ambling along; pose "hop" = reacting to
    // something clickable (mid-jump, motion dashes). its fleece takes the dye
    // colour of yarn-coloured things under the cursor.
    function setSheep(pose, fleece) {
      var colours = (Array.isArray(fleece) ? fleece : [fleece]).filter(function (c) { return /^#[0-9a-fA-F]{6}$/.test(c); });
      if (!colours.length) colours = [UNDYED];
      var key = pose + colours.join();
      if (key === lastKey) return;
      lastKey = key;
      var out = shade(colours[0], 0.62);
      var hop = pose === "hop";
      // the fleece splits evenly into the yarn's dyes: half and half for two,
      // thirds for three — one hard-edged gradient across the whole sheep
      var stops = colours.map(function (c, i) {
        var a = (i / colours.length * 100).toFixed(1), b = ((i + 1) / colours.length * 100).toFixed(1);
        return '<stop offset="' + a + '%" stop-color="' + c + '"/><stop offset="' + b + '%" stop-color="' + c + '"/>';
      }).join("");
      var defs = '<defs><linearGradient id="m" gradientUnits="userSpaceOnUse" x1="5.5" y1="0" x2="28.5" y2="0">' + stops + '</linearGradient></defs>';
      var body = defs +
        '<g fill="url(#m)" stroke="' + out + '" stroke-width="1">' +
        '<circle cx="12" cy="10.5" r="4"/><circle cx="17" cy="9" r="4.4"/><circle cx="22" cy="10.5" r="4"/>' +
        '<circle cx="24.5" cy="14.5" r="3.8"/><circle cx="9.5" cy="14" r="3.8"/>' +
        '<ellipse cx="17" cy="15.5" rx="9.5" ry="6.5" stroke="none"/></g>' +
        '<circle cx="27" cy="12" r="1.9" fill="url(#m)" stroke="' + out + '" stroke-width=".8"/>' +
        '<g fill="' + INK + '">' +
        '<path d="M8.6 8.4 q-3.6 -.6 -4.8 1.6 q2.6 1.6 4.6 .8z"/>' +
        '<rect x="3" y="9.2" width="7" height="6.8" rx="3.3"/>' +
        '</g>' +
        '<circle cx="5.9" cy="11.7" r=".95" fill="#fff"/>';
      var legs = hop
        ? '<g stroke="' + INK + '" stroke-width="2.1" stroke-linecap="round"><path d="M12 20.5 L10 24"/><path d="M15.5 21.5 L14 25"/><path d="M20.5 21.5 L22 25"/><path d="M24 20.5 L26 23.5"/></g>' +
          '<g stroke="' + INK + '" stroke-width="1.4" stroke-linecap="round" opacity=".55"><path d="M26.5 27.5 h4"/><path d="M24.5 30.3 h5"/></g>'
        : '<g stroke="' + INK + '" stroke-width="2.1" stroke-linecap="round"><path d="M12 20.5 V26.5"/><path d="M15.5 21 V27"/><path d="M20 21 V27"/><path d="M23.5 20.5 V26.5"/></g>';
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">' +
        (hop ? '<g transform="rotate(-18 16 16) translate(0 -2.5)">' : "<g>") + body + legs + "</g></svg>";
      document.documentElement.style.setProperty("--yarn-cursor", 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '") 4 13, auto');
    }
    setSheep("graze", UNDYED);
    document.addEventListener("mouseover", function (e) {
      if (!e.target || !e.target.closest) return;
      var dyed = e.target.closest("[data-sw], .swatch, .ticker li, .values li, .pillar");
      var interactive = e.target.closest("a, button, select, label, summary, .card");
      var fleece = UNDYED;
      if (dyed) {
        var sw = (dyed.getAttribute("data-sw") || getComputedStyle(dyed).getPropertyValue("--sw")).trim();
        var ref = sw.match(/^var\((--[\w-]+)\)$/);
        if (ref) sw = getComputedStyle(document.documentElement).getPropertyValue(ref[1]).trim();
        fleece = sw.split(",").map(function (c) { return c.trim(); });
      }
      setSheep(dyed || interactive ? "hop" : "graze", fleece);
    });
  }
  // the ambient cabin clip runs at double speed via the YouTube player API
  function fastEmbed() {
    var f = $(".bath__media--embed iframe");
    if (!f || f.src.indexOf("enablejsapi=1") === -1) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      try { f.contentWindow.postMessage(JSON.stringify({ event: "command", func: "setPlaybackRate", args: [2] }), "*"); } catch (err) {}
      if (tries > 20) clearInterval(t);
    }, 1000);
  }
  // play forward, then glide back to the start — a seamless ping-pong loop
  function pingpong() {
    $$("video[data-pingpong]").forEach(function (v) {
      v.removeAttribute("loop");
      var rate = parseFloat(v.getAttribute("data-rate")) || 1;
      v.playbackRate = rate;
      var last = null;
      function reverse(ts) {
        if (last !== null) v.currentTime = Math.max(0, v.currentTime - (ts - last) / 1000 * rate);
        last = ts;
        if (v.currentTime <= 0.05) { last = null; v.play().catch(function () {}); return; }
        requestAnimationFrame(reverse);
      }
      v.addEventListener("ended", function () { last = null; requestAnimationFrame(reverse); });
    });
  }

  function calmVideos() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      $$("video[autoplay]").forEach(function (v) { v.removeAttribute("autoplay"); v.pause(); });
      return;
    }
    // some browsers leave autoplay video paused after a background-tab load
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState !== "visible") return;
      $$("video[autoplay]").forEach(function (v) { if (v.paused) v.play().catch(function () {}); });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    indexDyes(); header(); ticker(); swatchWall(); enquiryForms(); year();
    calmVideos(); pingpong(); fastEmbed(); yarnCursor(); accountForms(); dressNames();
    // The catalogue, the home grid and the "shop N skeins" counts all wait on the
    // live product list. Everything else is already on screen, so it runs now.
    var needsProducts = $("#catalogue") || $("#featured") || $("#dye-library") || $("#sheep-library") || $(".pdp") || $(".card[data-overlay]");
    if (!needsProducts) { reveal(); return; }
    var grid = $("#catalogue") || $("#featured");
    if (grid) grid.setAttribute("data-loading", "true");
    loadProducts().then(function () {
      if (grid) grid.removeAttribute("data-loading");
      featured(); catalogue(); dyeLibrary(); sheepLibrary(); productPage(); dressCards(); reveal();
    });
  });
})();
